import { Map } from 'immutable';

import { DASHBOARD_DETAILS, DASHBOARD_SMS_STATS } from '../lib/constant';

const initialState = Map({websiteResponse : {}});

export default function(state = initialState , action ) {
	switch(action.type){
        case DASHBOARD_DETAILS :
            return {...state,dashboard:action.payload};
        case DASHBOARD_SMS_STATS :
            return {...state,smsStats:action.payload};
        default :
		     return state;
    }
}
